import React from "react";
import { Icon } from "@iconify/react";
import { useHistory } from "react-router-dom";
import "./Patient.scss"; // Make sure to import your CSS file
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import commObj from "../../../constants/Common";
import { CustomCard } from "../../CustomCard";
import { CreditCardIcon } from "../../../../assets";
import { toast } from "react-toastify";

export const PatientCard = ({ handleShow, data, dispatch }) => {
  const {
    user_first_name,
    user_last_name,
    user_iso_city_name,
    user_phone_nbr,
    user_iso_cntry_name,
    addr_street1,
    user_profile_id,
    gender_desc,
  } = data;
  const history = useHistory();

  const handleEdit = () => {
    history.push({
      pathname: "/dashboard/explore/add-patient",
      state: { patientData: data },
    });
  };
  const user_phone_nbrf = commObj.formatPhoneNumber(user_phone_nbr, "ZW");

  const handleAddNewPatient = () => {
    try {
      localStorage.setItem("newPatient", JSON.stringify(data));
      history.push(`/dashboard/`);
    } catch (error) {
      toast.error(
        `${
          error.response?.data?.usr?.message ||
          error.response?.data?.message ||
          error.response?.message ||
          error.message
        }`
      );
    }
  };

  return (
    <CustomCard className="facility patient-card">
      <div
        className="d-flex justify-content-between align-items-center !pb-3 !mb-4"
        style={{ borderBottom: "1px solid #E7E7E9" }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          <div className="rounded-5 border-slate-300 align-items-center justify-content-center d-flex bankCard_creditCardIcon">
            <CreditCardIcon />
          </div>
          <div>
            <h6 className="card-title mb-0">{`${user_first_name} ${user_last_name}`}</h6>
            <small>#{user_profile_id}</small>
          </div>
        </div>
        <div className="icons">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Edit Patient</Tooltip>}
          >
            <Icon
              onClick={handleEdit}
              icon="fluent:edit-48-filled"
              color="red"
              className="cursor-pointer"
            />
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Delete Patient</Tooltip>}
          >
            <Icon
              onClick={handleShow}
              icon="mingcute:delete-fill"
              color="red"
              className="cursor-pointer"
            />
          </OverlayTrigger>
        </div>
      </div>

      <div className="row gap-y-[18px]">
        <div className="col-6">
          <small>Gender:</small>
          <p className="truncate mb-0">{gender_desc}</p>
        </div>
        <div className="col-6">
          <small>Mobile No:</small>
          <p className="truncate mb-0">{user_phone_nbrf}</p>
        </div>
        <div className="col-6">
          <small>Address:</small>
          <p className="truncate mb-0">{addr_street1}</p>
        </div>
        <div className="col-6">
          <small>City Name:</small>
          <p className="truncate mb-0">{user_iso_city_name}</p>
        </div>
        <div className="col-6">
          <small>Country:</small>
          <p className="truncate mb-0"> {user_iso_cntry_name}</p>
        </div>

        <div className="flex flex-col justify-start gap-2">
          <button
            className="sign_btn !w-full !text-xs !flex !justify-center !items-center !gap-2"
            style={{ boxSizing: "border-box" }}
            onClick={(e) => {
              e.preventDefault();
              handleAddNewPatient();
            }}
          >
            <span className="mt-[2px]">Place an Order</span>
          </button>
        </div>
      </div>
    </CustomCard>
  );
};
